import { useState } from 'react';
import './DisclaimerNotice.css';

const STORAGE_KEY = 'bully-free-disclaimer-accepted';

function DisclaimerNotice({ onReadMore }) {
  const [visible, setVisible] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) !== 'true';
    } catch {
      return true;
    }
  });

  const acceptDisclaimer = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Keep the notice dismissible if browser storage is unavailable.
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="disclaimer-notice" aria-label="Important disclaimer">
      <div className="disclaimer-notice-copy">
        <p>
          Bully-Free Malaysia is a community initiative, not an emergency service
          or professional counselling provider.
        </p>
        <p>
          In immediate danger, call <a href="tel:999">999</a>.{' '}
          <button type="button" onClick={onReadMore}>Read the full disclaimer</button>
        </p>
      </div>
      <button
        className="disclaimer-accept"
        type="button"
        onClick={acceptDisclaimer}
      >
        I understand
      </button>
    </aside>
  );
}

export default DisclaimerNotice;